import { useEffect, useState } from 'react';
import { featuredRotation } from '@/mocks/books';

export interface FeaturedBookItem {
  id: string;
  title: string;
  subtitle: string;
  author: string;
  cover: string;
  link: string;
  paragraphs: string[];
  authorBio: string;
}

// The rotation starts in September 2026, where index 0 (Wired To Fight) is featured.
// Each following calendar month advances to the next title in the rotation.
const ROTATION_START_YEAR = 2026;
const ROTATION_START_MONTH = 8; // 0-indexed: 8 = September

const rotation = featuredRotation as FeaturedBookItem[];

export function getFeaturedBookOfTheMonth(date: Date = new Date()): FeaturedBookItem {
  const total = rotation.length;
  if (total === 0) {
    // Defensive fallback so the page always renders something
    return {
      id: 'fallback',
      title: 'Leavitt Peak Press',
      subtitle: '',
      author: 'Leavitt Peak Press',
      cover: '',
      link: 'https://www.amazon.com/s?k=leavitt+peak+press',
      paragraphs: ['Explore our curated collection of exceptional books from talented authors.'],
      authorBio: 'Leavitt Peak Press is a dedicated partner in literary success.',
    };
  }

  const monthDiff =
    (date.getFullYear() - ROTATION_START_YEAR) * 12 +
    (date.getMonth() - ROTATION_START_MONTH);

  const index = ((monthDiff % total) + total) % total;
  return rotation[index];
}

export function useFeaturedBook(): FeaturedBookItem {
  const [book, setBook] = useState<FeaturedBookItem>(() => getFeaturedBookOfTheMonth());

  useEffect(() => {
    // Keep the selection fresh for long-lived tabs, and re-check on mount.
    setBook(getFeaturedBookOfTheMonth());
    const timer = window.setInterval(() => {
      setBook(getFeaturedBookOfTheMonth());
    }, 60 * 60 * 1000); // re-evaluate hourly
    return () => window.clearInterval(timer);
  }, []);

  return book;
}